import React from "react";
import "../../../reusableComponents/SuccessModal/SuccessModal.scss";
import successIcon from "../../../assets/icons/AuthSuccessIcons.svg";
import CloseBtn from "../../../assets/icons/ClosebuttonModal.svg";
import {useDispatch, useSelector} from "react-redux";
import {clearMessages} from "../../../store/reducers/message";

function SuccessModal() {
  const dispatch = useDispatch();
  const [isClosing, setIsClosing] = React.useState(false);

  const handleClose = (e) => {
    if (e) e.preventDefault();
    setIsClosing(true);
    setTimeout(() => {
      dispatch(clearMessages());
      setIsClosing(false);
    }, 400);
  };

  const {title, msg, status} = useSelector((state) => state.message);

  return msg && status ? (
    <div
      className="success_modal_overlay"
      onClick={() => handleClose()}
    >
      <div
        className={`success_modal_container successPopupContainer ${
          isClosing ? "closing" : ""
        }`}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="popupIcon">
          <img
            src={successIcon}
            alt="successful tick"
          />
        </div>

        <div className="titleDesc">
          <h1>{title || "Success!"}</h1>
          <p>{msg}</p>
        </div>

        <div className="actionArea">
          {/* <button
            className="success_modal_close_btn"
            onClick={() => handleClose()}
          >
            {"Ok"}
          </button> */}
          <img
            src={CloseBtn}
            alt="Close Button"
            onClick={() => handleClose()}
            className="closeBtnSect"
          />
        </div>
      </div>
    </div>
  ) : (
    false
  );
}

export default SuccessModal;
